import type { PeriodTypeResponseDtoT, PeriodResponseDtoT } from "../../domain/dtos/periodType.dto";
import type { PeriodTypeEntityT, PeriodEntityT } from "../../domain/entities/periodType.entity";
import type { GetAllPeriodTypesResponseT, PeriodTypesMapperT } from "../types/periodTypes.types";

const mapPeriodToDomain = (item: PeriodResponseDtoT): PeriodEntityT => ({
  periodId: item.periodId,
  name: item.name,
  initialDate: item.initialDate,
  finalDate: item.finalDate,
});

const mapItemToDomain = (item: PeriodTypeResponseDtoT): PeriodTypeEntityT => ({
  periodType: item.periodType,
  name: item.name,
  periods: (item.periods ?? []).map(mapPeriodToDomain),
});

export const periodTypesMapper: PeriodTypesMapperT = {
  periodTypesDtoToDomain: (rawData: GetAllPeriodTypesResponseT): PeriodTypeEntityT[] =>
    (rawData?.results ?? []).map(mapItemToDomain),
};
